export default "__VITE_ASSET__73b146d7__"